var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-champion-cup",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "109") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.969,1 L3.082,1 L3.082,2.031 L-0.0078124993,2.0310001 L-0.0078124993,6.8670001 C-0.0078124993,8.7360001 2.078,10.274 4.125,10.434 C4.797,11.154 5.979,11.677 7.031,11.9 L7.031,13.164 C6.025,13.473 4.22800003,14.1989902 4.12500003,14.9899902 L11.0290523,14.9899902 C10.9250523,14.1989902 8.945,13.472 7.937,13.164 L7.937,11.9 C8.993,11.677 10.228,11.154 10.901,10.434 C12.947,10.274 14.941,8.736 14.941,6.867 L14.941,2.031 L11.969,2.031 L11.969,1 Z M0.941000006,2.9473877 L3.01000001,2.9473877 L3.01,7.113 C3.01,7.935 3.222,8.717 3.595,9.421 C2.047,8.928 0.941,7.658 0.941,6.172 L0.941000006,2.9473877 Z M9.0451968,8.028 L7.50083389,7.177 L5.9548032,8.028 L6.25,6.228 L5,4.954 L6.72698466,4.691 L7.50083389,3.055 L8.27301534,4.691 L10,4.954 L8.75083389,6.228 L9.0451968,8.028 L9.0451968,8.028 Z M11.34,9.554 C11.715,8.818 11.93,8.004 11.93,7.143 L11.93,2.97424316 L14.004,2.97424316 L14.004,6.16 C14.004,7.713 12.893,9.039 11.34,9.554 Z",
    fill: "#ffffff",
    className: "si-glyph-fill"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.a965881c701abe616c85c3437e90fbe3.svg";
export { ForwardRef as ReactComponent };